import React from 'react'
import PropTypes from 'prop-types'
import { Star } from 'lucide-react'
import { tokens } from '../../../assets/tokens'

// Estrella de favoritos de lucide: contorno gris si no es favorito, rellena en ámbar si lo es.
// `size` lo pasan algunas cabeceras de perfil pensando en el SvgIcon anterior: se ignora para que
// la estrella mida lo mismo en toda la app.
// eslint-disable-next-line no-unused-vars
const Icon = ({ favorite, onClick, style, size, ...rest }) => {
  const color = favorite ? tokens.color.warning.main : tokens.color.text.tertiary
  return (
    <Star
      id="svgFavorite"
      {...rest}
      size={18}
      strokeWidth={1.75}
      color={color}
      fill={favorite ? color : 'none'}
      style={{ cursor: 'pointer', flexShrink: 0, ...style }}
      onClick={onClick}
    />
  )
}

Icon.defaultProps = {
  favorite: false
}

Icon.propTypes = {
  favorite: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  onClick: PropTypes.func,
  style: PropTypes.object,
  size: PropTypes.number
}

export default Icon
